import { createBrowserHistory } from 'history';

import { BASEPATH } from '../env/variables';

const history = createBrowserHistory({
    basename: BASEPATH
});
export default history;
